export default __webpack_public_path__ + "static/media/4S6A0902.28c91a5f.JPG";